import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-fulfillment-common/fulfillment-tote-group";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateToteGroup = {
  name: "updateToteGroup" as const,
  input: z.object({ toteGroupId: zExt.objectId(), name: z.string() }),
  output: RedoFulfillmentToteGroupSchema,
};
